import Header from "@/components/Header";
import { Link } from "react-router-dom";
import { LayoutDashboard } from "lucide-react";

/** Platform header + a slim entry banner into the Admin HQ console.
 *  The old duplicated tab bar was replaced by the /hq sidebar layout. */
export default function AdminNav() {
  return (
    <>
      <Header />
      <div className="border-b border-neutral-800 bg-appcard/95" data-testid="admin-nav">
        <div className="px-4 md:px-8 py-2 flex items-center gap-3">
          <span className="text-[10px] tracking-[0.3em] text-neutral-500 heading">PLATFORM ADMIN</span>
          <Link to="/hq" data-testid="open-admin-hq-link"
            className="inline-flex items-center gap-1.5 text-[11px] tracking-widest text-volt hover:text-white transition-colors">
            <LayoutDashboard size={12} /> OPEN ADMIN HQ →
          </Link>
        </div>
      </div>
    </>
  );
}
